import React from "react";

import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";

function Carousel() {
  return (
    <div className="main-carousel border-bottom-style bg-carousel-img">
      <div className="container">
        <div className="row">
          <div className="col-sm-7">
            <h2 className="text-h-orange">
              “Two kinds of people can go into a grave, the dead and the living.
              For the dead a grave is at the graveyard, for the living it is at
              a jail.”
            </h2>
            <div className="col-sm-5"></div>
          </div>
        </div>
        <div className="row justify-content-center align-items-center">
          <div className="col-sm-5">
            <div className="mt-2 mx-5">
              <img
                style={{ width: "100%", height: "100%" }}
                src={require("../assets/images/intro-animation-try2.gif")}
                alt="intro-animation"
              />
            </div>
          </div>
          <div className="col-sm-7">
            <div className="mt-2 mx-5">
              <h2 className="mb-3 text-h-black">
                Serving Time: Pakistan’s Prisons Through the Ages
              </h2>
              <p>
                Explore the stories of former under-trial and convicted
                prisoners across Pakistan’s prison system in Punjab, Sindh,
                Khyber Pakhtunkhwa and Balochistan.
              </p>
              <p>
                Collected by author Radha Shah, these experiences of arrest and
                incarceration provide a historic and contemporary lens to
                understand the country’s penal system as part of the legacy of
                colonial governance in the Indian subcontinent, the creation of
                Pakistan, and current political debates that preoccupy the
                country under the umbrella of insecurity.
              </p>
            </div>
          </div>
        </div>
        <div className="py-5">
          {/* <h2 className="text-h-black">Introduction</h2> */}
          {/* <p>
            Each province of Pakistan presents a different story about the
            culture of criminalization across colonial history informing its
            post-Partition relationship with the federal state. In the stories
            of ex-prisoners featured in this book, historic and current state
            discourses of criminalization shape their everyday lives and
            culminate in their encounter with law enforcement during arrest.
            Then, in jail prisoners find themselves subjected to carceral
            modalities of securitization that are created and implemented
            through the application of regulations, procedures to prisoner
            classification, segregation and access to facilities and resources.
            This analysis pushes the boundaries of simplistic understanding of
            prison as a space of confining deviance to protect free society.
          </p> */}
          <p>
            Each province presents a different story about the culture of
            criminalisation across colonial history that also informs its
            post-Partition relationship with the federal state. Historic and
            current state discourses of criminalisation shape the everyday lives
            of prisoners and culminate in their encounter with law enforcement
            during arrest.
          </p>
          <br />
          <p>
            Then, in jail prisoners find themselves subjected to carceral
            modalities of securitisation that are created and implemented
            through the application of regulations, procedures of prisoner
            classification, segregation and access to facilities and resources.{" "}
          </p>
          <br />
          <p>
            Radha Shah’s analysis pushes the boundaries of simplistic
            understanding of prison as a space of confining deviance to protect
            free society.{" "}
          </p>

          <p className="text-hp-orange py-5">
            Explore each chapter of the book using the tabs above
          </p>
          {/* <h2 className="text-h-black">Prison Reform in Pakistan</h2> */}
          {/* <p>
            Pakistani jails are widely understood to be inhumane, withsevere
            overcrowding, physical abuse, inadequate medical facilities, and the
            spread of contagious diseases such as tuberculosis and HIV among the
            major problems. Despite considerable documentation about such
            longstanding fundamental rights violations, and the need for
            resources and capacities-based reforms by news, aid, prison
            advocacy, and human rights organisations alike, little change has
            come from provincial home departments and Islamabad. This absence of
            direction and action is not only part of a wider abysmal human
            rights record, that has seen extensive violence against religious
            and ethnic minorities and widespread socioeconomic underdevelopment
            across the country, it is also in line with an earlier history of
            spotty prison reform.
          </p>
          <p>
            Aside from media reporting on prisoner testimonies, and the
            communications drives of human rights organisations to amplify their
            experiences within justice, little is understood about life behind
            bars by the general public. There is some knowledge that in prisons
            physical atrocities such as beatings and torture take place at the
            hand of law enforcement officials and that it is egregious that
            those entrusted with the enforcement of law are the very same who
            violate it. Other than this, the prison system remains mystified and
            jails a hidden underworld of whose realities the general public
            knows very little. There is a lament for the lack of compassion for
            vulnerable people caught up in a life of crime due to limited
            options, alongside limited faith in a state unable to apprehend and
            prosecute actual violators of the law, such as perpetrators of
            militancy, and violent crimes of a sexual nature against women and
            children. However, among criminal lawyers, crime reporters, police,
            jail officials, and prisoners themselves, there is acute knowledge
            of how the penal system operates. They say that these are spaces
            that inflict corporal and disciplinary violence on prisoners’ minds
            and bodies; that this is part of a much larger social ecosystem of
            punitive relations.
          </p>
          <p>
            <i>
              This book{" "}
              <b> ‘Serving Time: Pakistan’s Prisons Through the Ages’</b> is
              part of Justice Project Pakistan’s prison reform campaign.
            </i>
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default Carousel;
